import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SnackbarService } from 'src/app/services/snackbar.sevice';
import { UserSettingsService } from 'src/app/services/user-settings.service';
import { AuthenticationService } from '../services/authentication.service';

@Component({
    selector: 'app-password-change',
    templateUrl: './password-change.component.html'
})
export class PasswordChangeComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private userSettingsService: UserSettingsService,
        private router: Router,
        private snackbarService: SnackbarService,
        private authenticationService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.userSettingsService.getResetPasswordLink().subscribe({
                next: passwordLink => {
                    this.redirect(passwordLink);
                },
                error: error => {
                    console.error('Unexpected error when redirecting to password change page.');
                    console.error(error);
                    // If they do not have a password change required, they will have manually attempted to change their password.
                    if (!this.authenticationService.getCurrentUser().passwordChangeRequired) {
                        this.snackbarService.openSnackBar(
                            'Your password could not be changed at this time. Please try again later or contact Everlight support.',
                            SnackbarService.SNACK_BAR_CLASS_ALERT
                        );
                    }
                    this.router.navigate(['/']);
                }
            })
        );
    }

    // This is a separate method for testing/mocking purposes.
    redirect(url: string) {
        this.document.location.href = url;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
